import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 570px) {
    flex-direction: column;
  }
`;

export const Left = styled.div`
  flex: 1;
  margin-right: 4.6rem;
  @media (max-width: 570px) {
    margin-right: 0;
    margin-bottom: 4.6rem;
  }
`;

export const Right = styled.div`
  flex: 2;
  @media (max-width: 767px) {
    flex: 3;
  }
  @media (max-width: 570px) {
    border-top: 1px solid black;
    padding-top: 1.3rem;
  }
`;
